import {
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
} from "antd";
import React from "react";
import { useClient } from "../../Context/ClientContext";
import ItemsService from "../../Services/ItemsService";
import { dayjs } from "../../../Utilities/dayjs";
import { notificationContext } from "../../Common/Routing/PageRoute";
import { useLocation } from "react-router-dom";

const SelectSerialNo: React.FC<{
  open: boolean;
  onCancel: any;
  id: any;
  setInInvoice: (parma: any) => void;
  setBatchItmName: (parma: any) => void;
  setForAddSerialData: (parma: any) => void;
  setSerial: (parma: any) => void;
  serial: any;
  setTriggerSerialData: any;
  inputFieldNull: () => void;
  alReadySelectedData: any;
  forAddSerialData: any;
  selectedBatchData: any;
  setSelectedBatchData: any;
}> = (props) => {
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const { currentClient } = useClient();
  const location = useLocation();
  const [data, setData] = React.useState<any[]>([]);
  const [serialData, setSerialData] = React.useState<any[]>([]);
  const [secFormserialData, setSecFormSerialData] = React.useState<any[]>([]);
  const [searchVal, setSearchVal] = React.useState<any>();
  const [loading, setLoading] = React.useState(false);
  const [addBtnLoading, setAddBtnLoading] = React.useState<boolean>(false);
  const [itmName, setItmName] = React.useState<any>();
  const [formTwoData, setFormTwoData] = React.useState<any[]>([]);
  // const [secFormSeriolNo, setSecFormSerialNo] = React.useState<any[]>();
  const handleValuesChange = (changedValues: any, allValues: any) => {
    const batches = allValues.serialNo;
    setData(batches);
  };

  const secFormVal = (changedValues: any, allValues: any) => {
    const batches2 = (allValues?.addSeriolNo ?? []).map((item: any) => ({
      ...item,
      type: 1,
      itemAddType: 1,
    }));
    form2.setFieldsValue({ batches2 });
    setFormTwoData(batches2);
  };

  const { openNotification } = React.useContext(notificationContext);
  const mergedData = [...data, ...secFormserialData, ...props.serial];
  const saveData = () => {
    form.validateFields().then(() => {
      props?.setInInvoice(
        data?.length ? data : props?.selectedBatchData?.serialItem
      );
      props?.setBatchItmName(itmName);
      props?.setForAddSerialData(formTwoData ?? secFormserialData);
      props?.setSerial(mergedData);
      props?.setTriggerSerialData((x: boolean) => !x);
      props?.onCancel(false);
      console.log("mergedData", mergedData);
    });
  };

  console.log("data", data);
  console.log("formTwoData", formTwoData);
  console.log("forAddSerialData", props?.forAddSerialData);

  console.log("serial??", props?.serial);
  // React.useEffect(() => {
  //   const margeData = [
  //     ...secFormserialData,
  //     ...(props?.forAddSerialData ?? []),
  //   ];
  //   setSecFormSerialNo(margeData);
  // }, []);
  const filterSerial = props?.serial?.filter((itm: any) => itm !== undefined);

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res = await ItemsService.getItem(currentClient?.id, props?.id);
      if (res?.result) {
        setItmName(res.result.inventoryItem?.name);
        if (location.pathname.split("/")[4] === "sales") {
          const matchItems = res.result.inventoryItem?.serialItem;
          setSerialData(matchItems);
          setLoading(false);
        }
        setLoading(false);
      } else {
        console.error("Client ID or props ID is missing.");
        setLoading(false);
      }
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, props?.id, form]);

  // console.log("selectedBatchData", props?.selectedBatchData);
  // console.log("itmName", itmName);

  const check = props?.selectedBatchData?.name === itmName;

  React.useEffect(() => {
    if (check && props?.selectedBatchData?.serialItem?.length) {
      form.setFieldsValue({
        serialNo: props.selectedBatchData.serialItem.map((d: any) => ({
          serialNumber: d?.serialNumber || "",
          modalNo: d?.modalNo ?? "",
          warranty: d?.warranty ? dayjs(d.warranty) : null,
        })),
      });
    }
  }, [check, props?.selectedBatchData, form]);

  const handleAddSerialNumber = async () => {
    setAddBtnLoading(true);
    if (
      props?.serial &&
      props?.serial.some((item: any) => item.serialNumber === searchVal)
    ) {
      openNotification("error", "Serial No already exists");
      setSearchVal("");
      setAddBtnLoading(false);
      return;
    }
    setAddBtnLoading(true);
    const isSerialExists = await ItemsService.getSerialNo(
      currentClient?.id,
      searchVal
    ).then((x) => x.result);

    if (isSerialExists) {
      openNotification("error", "Serial No already exist");
      setSearchVal("");
      setAddBtnLoading(false);
      return;
    }

    if (searchVal) {
      const newEntry = {
        serialNumber: searchVal,
        modalNo: 0,
        warranty: dayjs() || null,
        type: 1,
      };

      const existingList = form2.getFieldValue("addSeriolNo") || [];
      const updatedList = [...existingList, { ...newEntry }];
      setSecFormSerialData((prev) => [...prev, newEntry]);
      props?.setSerial((prev: any) => [...prev, newEntry]);
      setFormTwoData((prev) => [...prev, newEntry]);
      form2.setFieldsValue({
        addSeriolNo: updatedList.map((d: any, index: number) => ({
          serialNumber: d.serialNumber || "",
          modalNo: d.modalNo ?? "",
          warranty: d.warranty ? dayjs(d.warranty) : null,
          type: 1,
        })),
      });
      setSearchVal("");
      setAddBtnLoading(false);
    }
  };

  return (
    <>
      <Modal
        width={800}
        title={`${
          location.pathname.split("/")[4] === "purchase"
            ? "Add Serial No."
            : "Select Serial No."
        }`}
        onCancel={() => props?.onCancel(false)}
        open={props?.open}
        maskClosable={false}
        closable={false}
        footer={
          <>
            <Row justify={"end"} gutter={10}>
              <Col>
                <Button
                  disabled={
                    !(
                      (props?.selectedBatchData?.serialItem?.length || 0) > 0 ||
                      (formTwoData?.length || 0) > 0 ||
                      (data?.length || 0) > 0 ||
                      (props?.serial?.length || 0) > 0
                    )
                  }
                  type="primary"
                  onClick={() => saveData()}
                >
                  Save
                </Button>
              </Col>
              <Col>
                {props?.selectedBatchData?.serialItem ? (
                  <>
                    <Button
                      onClick={() => {
                        props?.setSelectedBatchData([]);
                        props?.setTriggerSerialData((x: boolean) => !x);
                        if (check) {
                          props?.setInInvoice(
                            props?.selectedBatchData?.serialItem
                          );
                        } else {
                          props?.setInInvoice([]);
                          props?.inputFieldNull();
                        }
                        props?.onCancel(false);
                      }}
                    >
                      Cancell
                    </Button>
                  </>
                ) : (
                  <Button
                    onClick={() => {
                      props?.setInInvoice([]);
                      props?.inputFieldNull();
                      props?.onCancel(false);
                    }}
                  >
                    Cancel
                  </Button>
                )}
              </Col>
            </Row>
          </>
        }
      >
        <Spin indicator={<LoadingOutlined />} spinning={loading}>
          {(location.pathname.split("/")[4] === "sales" ||
            (props?.selectedBatchData?.serialItem?.length > 0 &&
              location.pathname.split("/")[4] === "purchase")) && (
            <Form
              initialValues={{
                serialNo: [{}],
              }}
              form={form}
              onValuesChange={handleValuesChange}
              style={{ marginTop: "30px" }}
            >
              <table className="AddPageTabelDesign" style={{ width: "100%" }}>
                <>
                  <thead>
                    <tr>
                      <th>Serial No.</th>
                      <th>Modal No.</th>
                      <th>Warranty Date</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                </>
                <tbody>
                  <Form.List name="serialNo">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map((field, name) => (
                          <tr key={field.key}>
                            <td style={{ width: "33%" }}>
                              <Form.Item
                                name={[name, "serialNumber"]}
                                className="m-0"
                                rules={[
                                  {
                                    required: secFormserialData?.length
                                      ? false
                                      : name === fields.length - 1 &&
                                        fields.length !== 1
                                      ? false
                                      : true,
                                    message: "Please enter serial No!",
                                  },
                                ]}
                              >
                                <Select
                                  style={{ width: "100%" }}
                                  optionLabelProp="title"
                                  disabled={
                                    props?.alReadySelectedData?.serialItem
                                      ?.length > 0
                                      ? true
                                      : false
                                  }
                                  dropdownRender={(menu) => (
                                    <div style={{ padding: 8 }}>{menu}</div>
                                  )}
                                  placeholder="Serial Number"
                                  options={serialData
                                    ?.filter((batch) => {
                                      const selectedSerials = fields?.map(
                                        (f, i) =>
                                          form.getFieldValue([
                                            "serialNo",
                                            i,
                                            "serialNumber",
                                          ])
                                      );

                                      const isAlreadySelected =
                                        selectedSerials.includes(
                                          batch.serialNumber
                                        );

                                      const isInSerialList =
                                        props?.serial?.some(
                                          (s: any) =>
                                            s?.serialNumber ===
                                            batch?.serialNumber
                                        );

                                      return !(
                                        isAlreadySelected || isInSerialList
                                      );
                                    })
                                    .map((batch) => ({
                                      value: batch?.serialNumber,
                                      label: (
                                        <>
                                          <span style={{ fontWeight: "bold" }}>
                                            {batch?.serialNumber}
                                          </span>
                                          <br />
                                          {batch?.warranty}
                                        </>
                                      ),
                                      key: batch?.serialNumber,
                                      title: batch?.serialNumber,
                                    }))}
                                  onChange={(value) => {
                                    const selectedBatch = serialData.find(
                                      (sdata) => sdata.serialNumber === value
                                    );
                                    if (selectedBatch) {
                                      const currentValues =
                                        form.getFieldValue("serialNo") || [];

                                      currentValues[name] = {
                                        ...currentValues[name],
                                        serialNumber: value,
                                        batchNumber: value,
                                        modalNo: selectedBatch?.modalNo,
                                        warranty: dayjs(
                                          selectedBatch?.warranty
                                        ),
                                      };

                                      form.setFieldsValue({
                                        serialNo: currentValues,
                                      });

                                      add();
                                    }
                                  }}
                                />
                              </Form.Item>
                            </td>
                            <td style={{ width: "30%" }}>
                              <Form.Item
                                name={[name, "modalNo"]}
                                className="m-0"
                              >
                                <Input
                                  placeholder="Modal Number"
                                  disabled={true}
                                />
                              </Form.Item>
                            </td>
                            <td>
                              <Form.Item
                                name={[name, "warranty"]}
                                className="m-0"
                              >
                                <DatePicker
                                  placeholder="Warranty Date"
                                  style={{ width: "100%" }}
                                  format={"DD/MM/YYYY"}
                                  disabled={true}
                                  disabledDate={(current) =>
                                    current <
                                    dayjs("1900-01-01", "YYYY-MM-DD").add(
                                      -1,
                                      "day"
                                    )
                                  }
                                />
                              </Form.Item>
                            </td>

                            <td align="center">
                              <Button
                                type="text"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => {
                                  const getData: any =
                                    form?.getFieldValue(["serialNo", name]) ||
                                    [];
                                  console.log("getData:", getData);

                                  const sNo = getData.serialNumber;

                                  const updatedAllSerial = filterSerial.filter(
                                    (serialItem: any) =>
                                      !sNo.includes(serialItem?.serialNumber)
                                  );

                                  props?.setSerial(updatedAllSerial);

                                  remove(field.name);
                                  console.log("seialll", props?.serial);
                                }}
                                disabled={fields.length === 1 ? true : false}
                              />
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </Form.List>
                </tbody>
              </table>
            </Form>
          )}

          {props?.alReadySelectedData?.serialItem?.length ? (
            <></>
          ) : (
            <>
              {location.pathname.split("/")[4] === "purchase" && (
                <>
                  <Row style={{ margin: "7px 0px 15px 0px" }}>
                    <Col>
                      <Form.Item
                        label="Enter Serial No."
                        className="m-0"
                        rules={[
                          {
                            pattern: /^[a-zA-Z0-9]*$/,
                            message: "Special characters are not allowed!",
                          },
                        ]}
                      >
                        <Input
                          style={{ width: "300px" }}
                          value={searchVal}
                          onChange={(e) => setSearchVal(e.target.value)}
                          maxLength={20}
                          className="input"
                          addonAfter={
                            <>
                              <Button
                                onClick={handleAddSerialNumber}
                                size="small"
                                loading={addBtnLoading}
                                style={{ cursor: "pointer", border: "none" }}
                                disabled={!searchVal ? true : false}
                              >
                                <PlusOutlined />
                              </Button>
                            </>
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  {secFormserialData.length > 0 && (
                    <div style={{ maxHeight: "50ch", overflowY: "scroll" }}>
                      <Form
                        form={form2}
                        // initialValues={{
                        //   seriolNo: [{}],
                        // }}
                        onValuesChange={secFormVal}
                      >
                        <table
                          className="AddPageTabelDesign"
                          style={{ width: "100%" }}
                        >
                          <>
                            <thead>
                              <tr>
                                <th>Serial No.</th>
                                <th>Modal No.</th>
                                <th>Warranty Date</th>
                                <th>Delete</th>
                              </tr>
                            </thead>
                          </>

                          <tbody>
                            <Form.List name="addSeriolNo">
                              {(fields, { add, remove }) => (
                                <>
                                  {fields.map((field, name) => (
                                    <tr key={field.key}>
                                      <td>
                                        <Form.Item
                                          name={[name, "serialNumber"]}
                                          className="m-0"
                                        >
                                          <Input
                                            placeholder="Serial Number"
                                            disabled
                                            max={30}
                                          />
                                        </Form.Item>
                                      </td>
                                      <td style={{ width: "30%" }}>
                                        <Form.Item
                                          name={[name, "modalNo"]}
                                          className="m-0"
                                        >
                                          <Input
                                            placeholder="Modal Number"
                                            max={20}
                                          />
                                        </Form.Item>
                                      </td>
                                      <td>
                                        <Form.Item
                                          name={[name, "warranty"]}
                                          className="m-0"
                                        >
                                          <DatePicker
                                            placeholder="Warranty Date"
                                            style={{ width: "100%" }}
                                            format={"DD/MM/YYYY"}
                                            disabledDate={(current) =>
                                              current <
                                              dayjs(
                                                "1900-01-01",
                                                "YYYY-MM-DD"
                                              ).add(-1, "day")
                                            }
                                          />
                                        </Form.Item>
                                      </td>
                                      {/* 
                          <td>
                            <Form.Item name={[name, "status"]} className="m-0">
                              <Select
                                style={{ width: "140px" }}
                                options={[
                                  {
                                    value: BatchItemStatus.Available,
                                    label: "Available",
                                  },
                                  {
                                    value: BatchItemStatus.Sold,
                                    label: "Sold",
                                  },
                                  {
                                    value: BatchItemStatus.Expired,
                                    label: "Expired",
                                  },
                                  {
                                    value: BatchItemStatus.Damaged,
                                    label: "Damaged",
                                  },
                                  {
                                    value: BatchItemStatus.Returned,
                                    label: "Returned",
                                  },
                                ]}
                              />
                            </Form.Item>
                          </td> */}
                                      <td>
                                        <Button
                                          type="text"
                                          danger
                                          disabled={
                                            props?.alReadySelectedData
                                              ?.serialItem?.length > 0
                                              ? true
                                              : false
                                          }
                                          icon={<DeleteOutlined />}
                                          onClick={() => remove(field.name)}
                                        />
                                      </td>
                                    </tr>
                                  ))}
                                  {/* <Row gutter={15} style={{ marginTop: "10px" }}>
                        <Col>
                          <Button
                            type="primary"
                            size="small"
                            icon={<PlusOutlined />}
                            onClick={() => add(fields.length + 1)}
                          >
                            Add
                          </Button>
                        </Col>
                      </Row> */}
                                </>
                              )}
                            </Form.List>
                          </tbody>
                        </table>
                      </Form>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default SelectSerialNo;
